import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Send, ListChecks } from 'lucide-react';
import { EmailTester } from './EmailTester';
import { EmailEventsLog } from './EmailEventsLog';

export function EmailManager() {
  return (
    <Tabs defaultValue="event-log" className="space-y-6">
      <div className="rounded-xl border border-border/60 bg-card p-1.5">
        <TabsList className="grid w-full grid-cols-2 h-auto bg-transparent gap-1 p-0">
          <TabsTrigger value="event-log" className="gap-2">
            <ListChecks className="h-4 w-4" />
            <span className="hidden sm:inline">Event Log</span>
            <span className="sm:hidden">Log</span>
          </TabsTrigger>
          <TabsTrigger value="send-test" className="gap-2">
            <Send className="h-4 w-4" />
            <span className="hidden sm:inline">Send Test</span>
            <span className="sm:hidden">Test</span>
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="event-log" className="mt-0"><EmailEventsLog /></TabsContent>
      <TabsContent value="send-test" className="mt-0"><EmailTester /></TabsContent>
    </Tabs>
  );
}
